export default "__VITE_ASSET__0fc23750__"